<div *ngIf="controle">
  <div class="modal-header d-flex align-items-center gap-3">
    <h4 class="modal-title  mb-0 flex-grow-1" translate [translateParams]="{ numero: manquement.numero }" class="flex">
      page.controles.manquement.edit.title
      <ng-container *ngTemplateOutlet="statutManquement;context:{statut:manquement.statut, manquement:manquement}">
      </ng-container>
    </h4>
    <div class="small d-flex align-items-center gap-2"
         (mouseover)="showControlDetails=true"
         (mouseout)="showControlDetails=false"
         (focus)="showControlDetails=true"
         (blur)="showControlDetails=false">
      <h4>
        <fa-icon icon="info-circle"></fa-icon>
        Contrôle n° {{controle.numeroControle}}
      </h4>
    </div>
    <div class="pointer ms-auto">
      <fa-icon icon="times" (click)="onClose()"></fa-icon>
    </div>
  </div>

  <div *ngIf=" showControlDetails" style="margin-left: 20%; z-index: 5000; position: absolute;">
    <table class="tControlDetails" aria-label="Détails du contrôle">
      <tbody>
        <tr>
          <td style="font-size: 18px"><b>Contrôle n° {{ controle.numeroControle }}</b></td>
          <td>
            <b>{{'page.controles.manquement.controleDetails.typeControle' | translate}} : </b>
            {{ controle.nature.libelle }}</td>
        </tr>
        <tr>
          <td>
            <b>{{'page.controles.manquement.controleDetails.produit' | translate}} : </b>
            <br />
            {{ controleDetails.libelleProduit }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            <b>{{'page.controles.manquement.controleDetails.millesime' | translate}} :</b>
            <br />
            {{ controleDetails.millesime }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            <b>{{'page.controles.manquement.controleDetails.numeroLot' | translate}} :</b>
            <br />
            {{ controleDetails.numeroLot }}
          </td>
          <td>
            <b>{{'page.controles.manquement.controleDetails.volume' | translate}} :</b>
            <br />
            {{ controleDetails.volume }}
          </td>
        </tr>
        <tr>
          <td>
            <b>{{'page.controles.manquement.controleDetails.logement' | translate}} :</b>
            <br />
            {{ controleDetails.logement }}
          </td>
          <td>
            <b>{{'page.controles.manquement.controleDetails.datePrelevement' | translate}} :</b>
            <br />
            {{ controleDetails.datePrelevement | date:'dd/MM/yyyy' }}
          </td>
        </tr>
        <tr>
          <td>
            <b>{{'page.controles.manquement.controleDetails.numeroEchantillon' | translate}} :</b>
            <br />
            {{ controleDetails.numeroEchantillon }}
          </td>
          <td>
            <b>{{'page.controles.manquement.controleDetails.numeroExpertise' | translate}} :</b>
            <br /> {{ controleDetails.numeroExpertise }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Div de contenu de la fenêtre surgissante -->
  <div class="modal-body">
    <ng-container *ngIf="!chargementEnCours && controle && manquementDetail; else loading">
      <ul
        ngbNav
        #nav="ngbNav"
        (navChange)="onTabChange($event, nav)"
        class="nav-tabs"
      >
        <li ngbNavItem="constat">
          <a ngbNavLink>Constat</a>
          <ng-template ngbNavContent>
            <app-saisir-constat [controle]="controle" [(saisieLot)]="lot" [estOnglet]="true" #constat>
            </app-saisir-constat>
          </ng-template>
        </li>

        <li ngbNavItem="notification">
          <a ngbNavLink>Notification</a>
          <ng-template ngbNavContent>
            <app-saisir-notification [manquement]="manquementDetail" [estOnglet]="true" #notification>
            </app-saisir-notification>
          </ng-template>
        </li>

        <li ngbNavItem="decision">
          <a ngbNavLink>Decision</a>
          <ng-template ngbNavContent>
            <app-saisir-decision [(manquement)]="lot.lot[0]" [controle]="controle" [estOnglet]="true" #decision>
            </app-saisir-decision>
          </ng-template>
        </li>
        <li ngbNavItem="recours" *ngIf="manquementDetail.notification.recours">
          <a ngbNavLink>Recours</a>
          <ng-template ngbNavContent>
            <app-saisir-recours [(manquement)]="lot.lot[0]" [controle]="controle" [estOnglet]="true" #recours>
            </app-saisir-recours>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-3"></div>
    </ng-container>

    <!-- Boutons d'action -->
    <div class="actions-bar">
      <button type="button" class="btn btn-light" (click)="onClose()" translate>label.annuler</button>
      <button type="button" class="btn btn-primary ms-2" (click)="onSave()"
        translate>page.controles.manquement.edit.enregistrer</button>
    </div>
  </div>
</div>

<ng-template #statutManquement let-statut="statut" , let-manquement="manquement">
  <div ngbDropdown class="dropdown" class="statut-manquement" *hasRole="'DECLARATION_CONTROLE_ECRITURE'; elseDisable">
    <strong ngbDropdownToggle class="btn-sm dropdown-toggle pointer statut-manquement-current {{statut.code}}"
      data-bs-toggle="dropdown">
      {{statut.libelle}}
    </strong>
    <div class="dropdown-menu" ngbDropdownMenu>
      <span *ngFor="let statut of refStatuts" class="dropdown-item pointer statut-manquement-item {{statut.code}}"
        (click)="changeManquementStatut(manquement, statut)" (keydown.enter)="changeManquementStatut(manquement, statut)">
        {{statut.libelle}}
      </span>
    </div>
  </div>

</ng-template>

<ng-template #loading>
  Chargement du contrôle et du manquement en cours
</ng-template>
